<template>
    <div class="header-search" :class="{ 'is-busy': busy }">
        <input
            v-model="valueLocal"
            type="text"
            class="header-search-control"
            :placeholder="placeholder"
            :class="{ 'has-value': valueLocal }"
            :disabled="disabled"
        />
        <fa-icon icon="search" />
        <a v-if="valueLocal && !busy" class="header-search-clear" @click="valueLocal = ''">
            <fa-icon icon="times" />
        </a>
        <a v-if="busy" class="header-search-clear">
            <fa-icon icon="circle-notch" spin />
        </a>
    </div>
</template>

<script>
export default {
    emits: ['update:modelValue', 'search', 'clear'],

    props: {
        placeholder: { type: String, default: 'Search...' },
        busy: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        modelValue: { type: String, default: '' },
    },

    data() {
        return {
            valueLocal: '',
            search: null,
            clear: null,
        };
    },

    watch: {
        modelValue(value) {
            this.valueLocal = value;

            if (value) {
                this.handle('search');
            } else {
                this.handle('clear');
            }
        },

        valueLocal(value) {
            if (value) {
                this.handle('search');
            } else {
                this.handle('clear');
            }
        },
    },

    methods: {
        handle(type) {
            clearTimeout(this.search);
            clearTimeout(this.clear);

            this[type] = setTimeout(() => {
                this.$emit('update:modelValue', this.valueLocal);
                this.$emit(type, this.valueLocal);
            }, 300);
        },
    },
};
</script>
